<ng-container [ngSwitch]="featureData.mediaSourceType">
  <ng-container *ngSwitchCase="MediaSourceType.Video">
    <video height="360" autoplay loop muted>
      <source [src]="featureData.mediaSource" type="video/mp4" />
      <img
        *ngIf="featureData?.fallbackImgSource"
        alt="{{ featureData?.title }}"
        src="{{ featureData.fallbackImgSource }}"
        [style.minHeight]="'360px'"
      />
    </video>
  </ng-container>

  <ng-container *ngSwitchCase="MediaSourceType.YoutubeVideo">
    <iframe
      [src]="safeUrl"
      height="360"
      type="text/html"
      width="100%"
      frameborder="0"
      allowFullScreen
      mozallowfullscreen
      webkitAllowFullScreen
    >
    </iframe>
  </ng-container>

  <ng-container *ngSwitchCase="MediaSourceType.Image">
    <img
      alt="{{ featureData?.title }}"
      src="{{ featureData?.mediaSource }}"
      [style.minHeight]="'360px'"
    />
  </ng-container>
</ng-container>

<div layout-full-width layout-vertical layout-centered-y padding text-center>
  <rt-heading variant="heading large-xx">{{ featureData?.title }}</rt-heading>
  <div [innerHTML]="featureData?.description" margin-top-small-xx class="feature-desc"></div>
  <rt-feature-button
    *ngIf="canUpgrade"
    (openPlanPicker)="openPlanPicker.emit()"
    [plan]="featureData.plan"
    margin-top-small
    >{{ 'app.pricing.feature_guard.upgrade_plan' | translate }}</rt-feature-button
  >

  <ng-container *ngIf="featureData.helpArticleKey; else helpLinkTpl">
    <a [rtHelpArticle]="featureData.helpArticleKey" margin-top-small-x text-underline class="link">
      {{ featureData.learnMoreTranslationKey || 'app.common.learn_more' | translate }}
    </a>
  </ng-container>

  <ng-template #helpLinkTpl>
    <a
      [href]="featureData.helpUrl || featureData.learnMoreUrlByLang![helpArticleLang]"
      target="_blank"
      margin-top-small-x
      text-underline
      class="link"
      >{{ featureData.learnMoreTranslationKey || 'app.common.learn_more' | translate }}
    </a>
  </ng-template>
</div>
